import { render, staticRenderFns } from "./KpisByMunicipioMap.vue?vue&type=template&id=775f37b8&"
import script from "./KpisByMunicipioMap.vue?vue&type=script&lang=js&"
export * from "./KpisByMunicipioMap.vue?vue&type=script&lang=js&"
import style0 from "./KpisByMunicipioMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports